import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "enquiries--wrapper"
}
const _hoisted_2 = { class: "block-wrapper" }
const _hoisted_3 = { class: "row bold" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "row-value" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "row-value" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "requested-information" }
const _hoisted_11 = { class: "row-value" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "actions" }
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!$setup.loading && $setup.listing)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString($setup.enquiryTitle), 1),
          _createElementVNode("div", _hoisted_4, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row-title" }, "Listing :", -1)),
            _createElementVNode("div", {
              class: "row-value headline highlighted",
              onClick: $setup.onListing
            }, _toDisplayString($setup.listing.headline), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row-title" }, "Date:", -1)),
            _createElementVNode("div", _hoisted_6, _toDisplayString($setup.formatDate($setup.enquiries.receivedAt, "DD MMM YYYY")), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row-title" }, "Comments:", -1)),
            _createElementVNode("div", _hoisted_8, _toDisplayString($setup.enquiries.comments ? $setup.enquiries.comments : "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row-title top" }, "Requested Information:", -1)),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.enquiries.requestedInformation, (item) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString("- " + item), 1))
              }), 256))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row-title" }, "See Listing on:", -1)),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("a", {
                class: "row-value button primary default link",
                href: $setup.enquiries.listing.link,
                target: "_blank",
                rel: "noopener noreferrer"
              }, "realestate.com.au", 8, _hoisted_14)
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_15))
}